// assets
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import SafetyOutlined from '@ant-design/icons/SafetyOutlined';
import AppstoreOutlined from '@ant-design/icons/AppstoreOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import BankOutlined from '@ant-design/icons/BankOutlined';
import WalletOutlined from '@ant-design/icons/WalletOutlined';
import PieChartOutlined from '@ant-design/icons/PieChartOutlined';
import UnorderedListOutlined from '@ant-design/icons/UnorderedListOutlined';
import RobotOutlined from '@ant-design/icons/RobotOutlined';
import HistoryOutlined from '@ant-design/icons/HistoryOutlined';
import AIIcon from 'components/icons/AIIcon';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  TeamOutlined,
  SafetyOutlined,
  AppstoreOutlined,
  SettingOutlined,
  UserOutlined,
  BankOutlined,
  WalletOutlined,
  PieChartOutlined,
  UnorderedListOutlined,
  RobotOutlined,
  HistoryOutlined,
  AIIcon
};

// ==============================|| MENU ITEMS - PAGES ||============================== //

const pages: NavItemType = {
  id: 'group-pages',
  title: 'pages',
  type: 'group',
  children: [
    // 👇 Menu "Administração"
    {
      id: 'administration',
      title: 'administration',
      type: 'collapse',
      icon: icons.SettingOutlined,
      children: [
        {
          id: 'company',
          title: 'company',
          type: 'item',
          icon: icons.BankOutlined,
          url: '/company',
          rule: 'company.read'
        },
        {
          id: 'departments',
          title: 'departments',
          type: 'item',
          icon: icons.AppstoreOutlined,
          url: '/departments',
          rule: 'departments.read'
        },
        {
          id: 'roles',
          title: 'roles',
          type: 'item',
          icon: icons.SafetyOutlined,
          url: '/roles',
          rule: 'roles.read'
        },
        {
          id: 'collaborators',
          title: 'users',
          type: 'item',
          icon: icons.TeamOutlined,
          url: '/users',
          rule: 'users.read'
        },
        {
          id: 'clients',
          title: 'customer',
          type: 'item',
          icon: icons.UserOutlined,
          url: '/clients',
          rule: 'customers.read'
        },
        {
          id: 'ai-usage',
          title: 'ai-usage',
          type: 'item',
          icon: icons.AIIcon,
          url: '/ai-usage',
          rule: 'ai.usage.read'
        }
      ]
    },
    // 👇 Menu "Finanças da Família"
    {
      id: 'finance',
      title: 'finance',
      type: 'collapse',
      icon: icons.WalletOutlined,
      children: [
        {
          id: 'finance-dashboard',
          title: 'finance-dashboard',
          type: 'item',
          icon: icons.PieChartOutlined,
          url: '/finance',
          rule: 'finance.read'
        },
        {
          id: 'finance-transactions',
          title: 'finance-transactions',
          type: 'item',
          icon: icons.UnorderedListOutlined,
          url: '/finance/transactions',
          rule: 'finance.read'
        },
        {
          id: 'finance-chat',
          title: 'finance-chat',
          type: 'item',
          icon: icons.RobotOutlined,
          url: '/finance/chat',
          rule: 'finance.ai'
        },
        {
          id: 'finance-history',
          title: 'finance-history',
          type: 'item',
          icon: icons.HistoryOutlined,
          url: '/finance/history',
          rule: 'finance.read'
        },
        {
          id: 'finance-settings',
          title: 'finance-settings',
          type: 'item',
          icon: icons.SettingOutlined,
          url: '/finance/settings',
          rule: 'finance.read'
        }
      ]
    }
  ]
};

export default pages;
